import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { BLOG_ENABLED } from '../../config/blogConfig';
import { images } from '../../config/imagePaths';
import './navbar.css';

function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const buffer = 10;
      const currentScroll = window.scrollY;
      if (currentScroll > 40 && !scrolled) setScrolled(true);
      else if (currentScroll < 10 && scrolled) setScrolled(false);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [scrolled]);

  return (
    <header className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="logo">
        <Link to="/">
          <img src={images.branding.logo} alt="AOK Communications Logo" />
        </Link>
      </div>

      <button
        className={`hamburger ${menuOpen ? 'open' : ''}`}
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label="Toggle navigation"
      >
        <span className="bar"></span>
        <span className="bar"></span>
        <span className="bar"></span>
      </button>

      <nav className={`nav-links ${menuOpen ? 'open' : ''}`}>
        <Link to="/" onClick={() => setMenuOpen(false)}>Home</Link>

        <div className="dropdown">
          <Link className="dropbtn" to="/about">About Us ▾</Link>
          <div className="dropdown-content">
            <Link to="/what-we-value" onClick={() => setMenuOpen(false)}>What We Value</Link>
            <Link to="/meet-the-team" onClick={() => setMenuOpen(false)}>Meet the Team</Link>
            <Link to="/our-vision" onClick={() => setMenuOpen(false)}>Our Vision</Link>
          </div>
        </div>

        <div className="dropdown">
          <Link className="dropbtn" to="/services">Services ▾</Link>
          <div className="dropdown-content">
            <Link to="/public-speaking" onClick={() => setMenuOpen(false)}>Public Speaking</Link>
            <Link to="/digital-marketing" onClick={() => setMenuOpen(false)}>Digital Marketing</Link>
            <Link to="/web-design" onClick={() => setMenuOpen(false)}>Web Design</Link>
          </div>
        </div>

        {BLOG_ENABLED && (
          <Link to="/blogs" onClick={() => setMenuOpen(false)}>Blog</Link>
        )}
        <Link to="/contact" onClick={() => setMenuOpen(false)}>Contact Us</Link>
      </nav>
    </header>
  );
}

export default Header;
